import Base from './base'
import urls from 'config/urls'

class Region extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.region.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.region.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.region.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.region.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.region.delete,
      data: opts
    })
  }
}

export default new Region



// WEBPACK FOOTER //
// ./src/models/region.js